import React, { Component } from 'react'

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';

import { Link } from 'react-router-dom';

import Help from '@material-ui/icons/Help';
export default class ItemMenu extends Component {
    render() {
        const { nome, rota, icone, iconeAuxiliar, ordem, onClick, classes, expandAction, expanded, filhos } = this.props
        let iconeAux = ""
        if (iconeAuxiliar)
            iconeAux = iconeAuxiliar;
        let iconeUsar = <Help className={classes.menuItem} />;
        if (icone) {
            let Teste = icone
            iconeUsar = <Teste className={classes.menuItem} />;
        }
        if (expandAction) {
            filhos.sort((a, b) => (a.props.ordem > b.props.ordem) ? 1 : ((b.props.ordem > a.props.ordem) ? -1 : 0))
            return (<div>

                <ListItem button onClick={expandAction} >
                    <ListItemIcon >
                        {iconeUsar}
                    </ListItemIcon>
                    <ListItemText
                        disableTypography
                        primary={<Typography className={classes.menuItem}><span>{nome} {iconeAux}</span></Typography>}
                    />
                    {expanded ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={expanded} timeout="auto" style={{backgroundColor:"#000"}} unmountOnExit>
                    {filhos}
                </Collapse>
            </div>

            )
        } else {
            return (
                <Link to={rota} ordem={ordem} onClick={onClick}>
                    <ListItem button color="primary">
                        <ListItemIcon >
                            {iconeUsar}
                        </ListItemIcon>
                        <ListItemText
                            disableTypography
                            primary={<Typography className={classes.menuItem}><span>{nome} {iconeAux}</span></Typography>}
                        />

                    </ListItem>
                </Link>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/App/components/Menu/components/ItemMenu.js